import { all, fork } from 'redux-saga/effects';

import app from './app';
import flight from './flight-search';
import locations from './location';
import user from './user';
import flightBookingDetails from './flight-booking';
import tours from './tours';
import recommendations from './recommendations';
import itineraryWizard from './itinerary-wizard';
import itineraryPackages from './itinerary-packages';

/**
 * rootSaga
 */
export default function* root() {
  yield all([
    fork(app),
    fork(locations),
    fork(user),
    fork(flight),
    fork(flightBookingDetails),
    fork(tours),
    fork(recommendations),
    fork(itineraryWizard),
    fork(itineraryPackages),
  ]);
}
